export default __webpack_public_path__ + "static/media/logo-white.fc3cd627.svg";